import { Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AssessmentFindings from './AssessmentFindings';
import ReviewDetails from './ReviewDetails';
import UnfinishedControls from './UnfinishedControls';

function AssessmentReview() {
  const { t } = useTranslation();

  return (
    <Container maxWidth="false" disableGutters>
      <Stack variant="assessmentData" spacing={2}>
        <Typography>{t('assessment.review.description')}</Typography>
        <ReviewDetails />
        <Stack spacing={4}>
          <AssessmentFindings review />
          <UnfinishedControls />
        </Stack>
      </Stack>
    </Container>
  );
}
export default AssessmentReview;
